import { PackageOptionsVariant } from 'component/page/detail/DetailPageModularize/detailPageModularize.types';
import { DispatchProps, StateProps } from 'component/page/detail/PackageOptions/PackageOptionsWrapper.selectors';
import { TypographyType } from '@drone-js/theme';
import { PackageOptionsModularContextProps } from 'component/page/detail/PackageOptions/PackageOptionsModularContext';

export interface PackageOptionsModularProps {
    variant: PackageOptionsVariant;
}

interface PackageOptionsContentConfig extends PackageOptionsModularContextProps {
    titleFontSize: TypographyType;
}

export type Props = PackageOptionsModularProps & StateProps & DispatchProps;

export const PackageOptionsContentConfigMap: Record<PackageOptionsVariant, PackageOptionsContentConfig> = {
    [PackageOptionsVariant.Default]: { isHideOfferCalendar: false, isChipOfferOption: false, isExpandOfferCard: false, titleFontSize: 'body-s-strong' },
    [PackageOptionsVariant.Simplified]: { isHideOfferCalendar: true, isChipOfferOption: true, isExpandOfferCard: true, titleFontSize: 'heading-default' },
};
